function lerp(min, max, ratio) {
  return (1 - ratio) * min + ratio * max;
}
export {
  lerp
};
//# sourceMappingURL=lerp.js.map
